<template>
  <div
    :class="[
      'no-results',
      {
        'no-results--small': small,
        'no-results--design-new': design === 'new'
      }
    ]"
    :style="{ marginTop: `${marginTop}px`, marginBottom: `${marginBottom}px` }"
  >
    <template v-if="!small">
      <span v-if="design === 'new'" class="no-results__icon" aria-hidden="true" />
      <img v-else src="@/assets/img/schedule-plug-icon.svg" alt="">
    </template>
    <div class="no-results__title">{{ title }}</div>
    <div class="no-results__text">{{ text }}</div>
  </div>
</template>

<script>
export default {
  name: 'AppNoResults',
  props: {
    title: {
      type: String,
      default: 'No Results',
    },
    text: {
      type: String,
      default: 'There’s nothing to display at the moment.',
    },
    small: {
      type: Boolean,
      default: false,
    },
    design: {
      type: String,
      default: 'legacy',
      validator: value => ['legacy', 'new'].includes(value)
    },
    marginTop: Number,
    marginBottom: Number
  }
}
</script>

<style lang="sass" scoped>
.no-results
  display: flex
  justify-content: center
  align-items: center
  flex-direction: column
  width: 100%
  height: 158px
  gap: 10px
  border: 1px solid #e6e6e6
  background-color: #fcfcfc
  text-align: center

.no-results--small
  height: 90px

.no-results__title
  font-size: 13px
  font-weight: 600
  text-transform: uppercase

.no-results__text
  color: #7d7d7d
  font-size: 13px
  font-weight: 600

.family.no-results
  font-family: 'MazzardSoftH', system-ui

.no-results--design-new
  min-height: 158px
  height: auto
  padding: $ui-space-24
  gap: $ui-space-8
  border-color: $ui-line
  border-radius: $ui-panel-radius
  background-color: $ui-surface-soft
  color: $ui-text
  font-family: $ui-font-body

  .no-results__icon
    flex: 0 0 auto
    width: 32px
    height: 32px
    background-color: $ui-blue
    -webkit-mask: url('~@/assets/img/schedule-plug-icon.svg') center / contain no-repeat
    mask: url('~@/assets/img/schedule-plug-icon.svg') center / contain no-repeat

  .no-results__title
    color: $ui-ink
    font-size: $ui-font-size-section-title
    font-weight: 600
    text-transform: none

  .no-results__text
    max-width: 480px
    color: $ui-muted
    font-size: $ui-font-size-body
    font-weight: 400
    line-height: 1.5

  &.no-results--small
    min-height: 90px
    padding: $ui-space-16
</style>
